var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vue-progress-bar'),_vm._v(" "),_c('main-header'),_vm._v(" "),_c('main-sidebar',{staticClass:"content-margin"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }